import React from 'react';
import { Configure, Hits, Index, useInstantSearch } from 'react-instantsearch';
import { AlgoliaSearchHit } from '../../AlgoliaSearchHit/AlgoliaSearchHit';
import { ALGOLIA_INDEX_NAME } from 'constants/algolia';

import * as styles from './AlgoliaPopularEvents.css';
import Link from 'next/link';
import { createLinkToRedirect } from 'utils/createLinkToRedirect';
import { ANYWHERE_LOCATION_JSON } from 'constants/index';
import { IconClose } from '@sympla/sympla-components';

function EventsSection({
  query,
  hasMossColor,
  isNavbarCollapsed,
  isMobile,
  onClose
}: {
  query: string;
  hasMossColor: boolean;
  isNavbarCollapsed: boolean;
  isMobile: boolean;
  onClose: () => void;
}) {
  const { results } = useInstantSearch();

  if (!results?.nbHits) return null;

  return (
    <div className={styles.eventsSectionContainer}>
      <div className={styles.titleContainer}>
        <h3 className={styles.sectionTitle}>Eventos</h3>
        <div className={styles.eventsHeader}>
          <Link
            href={createLinkToRedirect({
              param: `?s=${query}`,
              routeType: 'search-bar-default-filter',
              userLocation: ANYWHERE_LOCATION_JSON
            })}
            className={`${styles.eventsLink} ${
              hasMossColor && styles.buttonLinkMoss
            } `}
          >
            Ver tudo
          </Link>
          {isNavbarCollapsed && !isMobile && (
            <IconClose
              width={20}
              height={20}
              onClick={() => onClose()}
              className={styles.closeInput}
              fill={hasMossColor ? '#669F2A' : '#0097FF'}
            />
          )}
        </div>
      </div>
      <div className={styles.eventsContainer}>
        <Hits
          hitComponent={AlgoliaSearchHit}
          classNames={{
            list: styles.HitsList
          }}
        />
      </div>
    </div>
  );
}

export default function AlgoliaPopularEvents({
  userTokenAlgolia,
  hitsLimit,
  query,
  isNavbarCollapsed,
  hasMossColor,
  isMobile,
  onClose
}: {
  userTokenAlgolia: string;
  hitsLimit: number;
  query: string;
  isNavbarCollapsed: boolean;
  hasMossColor: boolean;
  isMobile: boolean;
  onClose: () => void;
}) {
  return (
    <div data-testid="search-algolia-dropdown-events">
      <Index indexName={ALGOLIA_INDEX_NAME}>
        <Configure hitsPerPage={hitsLimit} userToken={userTokenAlgolia} />
        <EventsSection
          query={query}
          isNavbarCollapsed={isNavbarCollapsed}
          hasMossColor={hasMossColor}
          isMobile={isMobile}
          onClose={onClose}
        />
      </Index>
    </div>
  );
}
